module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/redzel.e27d05f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/redzel.jpg
// module id = iuSX
// module chunks = 0